// Vendor
import * as React from 'react';

// Internal
import { ChartESG } from '@src/charts/ChartESG';
import { Image } from '@src/components/Image';
import { SlideReveal } from '@src/components/SlideReveal';
import { DEFAULT_SAL_PROPS, SAL_DELAY } from '@src/config/sal';

const InvestorsGetSerious: React.FC = () => {
  return (
    <div className="tup-slide">
      <h1 {...DEFAULT_SAL_PROPS} className="max-w-2xl">
        Investors Get Serious About Sustainable Brands
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-3 md:gap-12">
        <div className="col-span-2">
          <p className="tup-body clear-bothmax-w-xl">
            Investors consider ESG investing—managing money according to
            environmental, social, and governance factors—both profitable and
            beneficial to society.
          </p>

          <h2
            {...DEFAULT_SAL_PROPS}
            data-sal-delay={SAL_DELAY * 2}
            className="mt-12"
          >
            ESG assets will grow from 11% in 2012 to 50% in 2025.
          </h2>
          <div className="hidden md:block" style={{ height: 480 }}>
            <ChartESG />
          </div>
          <SlideReveal>
            <Image
              alt="ESG vs non-ESG Chart"
              addLink={true}
              className="block md:hidden"
              fileName="1j-chart-mobile.png"
            />
          </SlideReveal>
          <p
            {...DEFAULT_SAL_PROPS}
            data-sal-delay={SAL_DELAY * 3}
            className="tup-description"
          >
            professionally managed assets in the united states (US$ trillion)
          </p>
          <p
            {...DEFAULT_SAL_PROPS}
            data-sal-delay={SAL_DELAY * 3}
            className="tup-source"
          >
            Source: US SIF Foundation through 2018, Deloitte Center for
            Financial Services analysis through 2025
          </p>
        </div>
        <div
          {...DEFAULT_SAL_PROPS}
          data-sal-delay={SAL_DELAY * 3}
          data-sal="fade"
          className="bg-brand-background p-6 mt-8 md:mt-0"
        >
          <h2 className="mb-4">Sustainability Investment Highlights</h2>
          <div
            {...DEFAULT_SAL_PROPS}
            // data-sal="fade"
            data-sal-delay={SAL_DELAY * 4}
            className="border-b border-brand border-solid pt-6 pb-6"
          >
            <p>
              <strong>December 19, 2019</strong>
              <br />
              Goldman Sachs announces plan to spend $750B over the next decade
              financing and advising companies focused on sustainable finance
              themes.
            </p>
            <Image
              alt="Goldman Sachs Logo"
              className="mt-2"
              fileName="goldmansachs-logo.png"
              maxWidth={70}
            />
          </div>
          <div
            {...DEFAULT_SAL_PROPS}
            // data-sal="fade"
            data-sal-delay={SAL_DELAY * 5}
            className="border-b border-brand border-solid pt-6 pb-6"
          >
            <p>
              <strong>January 8, 2020</strong>
              <br /> BloombergNEF (New Energy Finance) announced that 2019 saw a
              record $465B of sustainable debt issued globally, up 78% from
              $261B in 2018.
            </p>
            <Image
              alt="Bloomberg NEF logo"
              className="mt-2"
              fileName="bloombernef-logo.png"
              maxWidth={130}
            />
          </div>
          <div
            {...DEFAULT_SAL_PROPS}
            // data-sal="fade"
            data-sal-delay={SAL_DELAY * 6}
            className="pt-6"
          >
            <p>
              <strong>January 14, 2020</strong>
              <br />
              BlackRock releases letter on sustainability to all clients,
              announcing plan to double its number of ESG exchange-traded fund
              offerings and make ESG analysis a key component of portfolio
              construction.
            </p>
            <Image
              alt="Bloomberg NEF logo"
              className="mt-2"
              fileName="blackrock-logo.png"
              maxWidth={105}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export { InvestorsGetSerious };
